import { useActivitiesContext } from '../../../context'
import { useMemo } from 'react'
import { ActivityStatus } from '@user/features/Activity'

export function useData() {
  const [{ activities }] = useActivitiesContext()
  const showList = activities.length > 0

  const deferredActivities = useMemo(
    () =>
      activities.filter(
        (activity) => activity.status === ActivityStatus.Deferred,
      ),
    [activities],
  )

  const completedActivities = useMemo(
    () =>
      activities.filter(
        (activity) => activity.status === ActivityStatus.Complete,
      ),
    [activities],
  )

  const activeActivities = useMemo(
    () =>
      activities.filter(
        (activity) =>
          activity.status !== ActivityStatus.Complete &&
          activity.status !== ActivityStatus.Deferred,
      ),
    [activities],
  )

  return {
    showList,
    deferredActivities,
    completedActivities,
    activeActivities,
  }
}
